import { createTheme } from 'flowbite-react';

export const docsTabsTheme = createTheme({
  tabs: {
    base: 'flex flex-col',
    tablist: {
      base: 'flex gap-4 items-center bg-white p-4 rounded-lg w-fit shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)]',
      tabitem: {
        base: 'flex items-center justify-center px-4 py-2 p-0 rounded-lg text-sm font-normal leading-[1.5] first:ml-0 focus:outline-none disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500',
        variant: {
          default: {
            base: 'px-4 py-2',
            active: {
              on: 'bg-brand-green-900 text-white',
              off: 'text-gray-500 hover:bg-gray-100 hover:text-gray-700',
            },
          },
        },
        icon: 'mr-2 h-5 w-5',
      },
    },
    tabpanel: '',
  },
}).tabs;

export const dropdownTheme = createTheme({
  content: 'p-2 cursor-pointer',
  floating: {
    base: 'z-50 rounded-lg bg-white shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.05)]',
    content: 'p-2 gap-1',
    target: 'w-full',
    item: {
      base: 'flex w-full cursor-pointer items-center justify-start text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:bg-gray-600 dark:focus:text-white',
      icon: 'mr-2 h-4 w-4',
    },
  },
});

export const textInputTheme = {
  field: {
    input: {
      base: 'cursor-pointer',
    },
  },
};

const tableTheme = {
  root: {
    base: 'w-full text-left text-sm text-gray-500 dark:text-gray-400 relative z-0',
    shadow: '',
    wrapper: 'relative',
  },
};

export const customTheme = createTheme({
  table: tableTheme,
  dropdown: {
    content: 'p-0 cursor-pointer rounded-lg overflow-hidden',
    floating: {
      base: 'z-50 rounded-lg bg-white shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.05)]',
      content: 'p-2 gap-1 ',
      target: 'w-full',
      item: {
        base: 'flex w-full cursor-pointer items-center justify-start text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:bg-gray-600 dark:focus:text-white',
        icon: 'mr-2 h-4 w-4',
      },
    },
  },
  button: {
    size: {
      xs: 'h-8 px-2 text-xs',
      sm: 'h-9 px-2 text-sm',
      md: 'h-10 px-4 text-sm',
      lg: 'h-12 px-5 text-base',
      xl: 'h-[52px] px-6 text-base',
    },

    color: {
      base: 'px-4 py-2 z-10',
      primary:
        'py-2 bg-brand-purple-900 hover:bg-brand-purple-500 text-white focus:ring-4 focus:ring-brand-purple-100',
      purple:
        'bg-purple-900 hover:bg-purple-700 text-white focus:ring-4 focus:ring-purple-300',
      gray: 'bg-gray-200 hover:bg-gray-300 text-gray-900 focus:ring-4 focus:ring-gray-100',
      alternative:
        'border-brand-green-500/50 text-brand-green-900 hover:bg-brand-green-50 hover:text-brand-green-900',
      second:
        'bg-white border border-gray-200 text-gray-900 hover:bg-gray-50 hover:text-gray-900 focus:ring-4 focus:ring-gray-100',
      red: 'bg-red-700 text-white',
    },
    outlineColor: {
      primary:
        'border border-brand-purple-900 text-brand-purple-900 hover:text-brand-purple-900 hover:bg-brand-purple-900 hover:text-white focus:ring-brand-purple-900',
    },
  },
  alert: {
    color: {
      info: 'bg-gray-50 text-gray-800 border-gray-200',
    },
  },
  badge: {
    root: {
      color: {
        green: 'bg-brand-green-900 text-white font-normal',
        lightGreen: 'bg-green-150 text-green-800 font-medium',
        purple: 'bg-brand-purple-50 text-brand-purple-900',
        red: 'bg-red-100 text-red-800 font-medium',
      },
    },
  },
  card: {
    root: {
      children: 'flex h-full flex-col justify-center gap-6 p-6',
    },
  },
});

export const adminTheme = createTheme({
  table: tableTheme,
  button: {
    size: {
      xs: 'h-8 px-2 text-xs',
      sm: 'h-9 px-2 text-sm',
      md: 'h-10 px-4 text-sm',
      lg: 'h-12 px-5 text-base',
      xl: 'h-[52px] px-6 text-base',
    },

    color: {
      base: 'px-4 py-2',
      primary:
        'py-2 bg-blue-600 hover:bg-blue-700 text-white focus:ring-4 focus:ring-blue-100',
      purple:
        'bg-blue-600 hover:bg-blue-700 text-white focus:ring-4 focus:ring-blue-300',
      gray: 'bg-gray-200 hover:bg-gray-300 text-gray-900 focus:ring-4 focus:ring-gray-100',
      alternative:
        'border-brand-green-500/50 text-brand-green-900 hover:bg-brand-green-50 hover:text-brand-green-900',
      second:
        'bg-white border border-gray-200 text-gray-900 hover:bg-gray-50 hover:text-gray-900 focus:ring-4 focus:ring-gray-100',
    },
  },
  alert: {
    color: {
      info: 'bg-blue-50 text-blue-800 border-blue-200',
    },
  },
  badge: {
    root: {
      color: {
        green: 'bg-gray-800 text-white font-normal',
      },
    },
  },
});
